/* eslint-disable prefer-spread, no-extend-native */
Array.range = function (n) {
  // Array.range(5) --> [0,1,2,3,4]
  return Array.apply(null, Array(n)).map((x, i) => i);
};

Object.defineProperty(Array.prototype, 'chunk', {
  value: function (n) {
    return Array.range(Math.ceil(this.length / n)).map((x, i) => this.slice(i * n, i * n + n));
  }
});
